import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large CompanyDirectionsActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить направление компании?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.companyId) = $event)),
        placeholder: "Компания",
        "search-without-refresh": "",
        "error-text": "При получении списка компаний произошла ошибка",
        "select-by": "id",
        disabled: _ctx.loading,
        "is-invalid": _ctx.state_form$.companyId.$error,
        "validation-errors": _ctx.state_form$.companyId.$errors,
        loading: _ctx.data_state.companies.is_loading,
        options: _ctx.data_state.companies.list,
        failed: _ctx.data_state.companies.is_failed,
        onRefresh: _ctx.loadCompanies
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        value: _ctx.state.directionId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.directionId) = $event)),
        placeholder: "Направление",
        "search-without-refresh": "",
        "error-text": "При получении списка направлений произошла ошибка",
        "select-by": "id",
        "search-by": "fromCityName",
        disabled: _ctx.loading,
        "is-invalid": _ctx.state_form$.directionId.$error,
        "validation-errors": _ctx.state_form$.directionId.$errors,
        loading: _ctx.data_state.directions.is_loading,
        options: _ctx.data_state.directions.list,
        failed: _ctx.data_state.directions.is_failed,
        onRefresh: _ctx.loadDirections
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.fromCityName) + " - " + _toDisplayString(option.whereCityName), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.fromCityName) + " - " + _toDisplayString(option.whereCityName), 1)
        ]),
        _: 1
      }, 8, ["value", "disabled", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        label: "Активно",
        disabled: _ctx.loading,
        value: _ctx.state.isActive,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.isActive) = $event))
      }, null, 8, ["disabled", "value"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}